module.exports = __webpack_public_path__ + "img/48.4eb6c5f1.jpg";